import { DataObject } from "core/types/DataObject";

/**
 * core/types/TagManagerObject
 * ----------------------------------------------------------------------
 * @since     0.0.1
 */
export class TagManagerObject extends DataObject {
  utmSource = null;
  utmCampaign = null;
  utmMedium = null;
  utmContent = null;
  registrationUrl = null;
  registrationMedium = null;

  constructor (
    utmSource = null,
    utmCampaign = null,
    utmMedium = null,
    utmContent = null,
    registrationUrl = null,
    registrationMedium = null
  ) {
    super();

    this.utmSource = utmSource || null;
    this.utmCampaign = utmCampaign || null;
    this.utmMedium = utmMedium || null;
    this.utmContent = utmContent || null;
    this.registrationUrl = registrationUrl || null;
    this.registrationMedium = registrationMedium || null;
  }
}
